import { defaultColors } from '../../../Common/Services/contexts/ServicesChartsDataContext';
import { Gauge } from '../../../Common/Charts/Gauge';
import { useServicesChartsDataContext } from './hooks/useServicesChartsDataContext';

export const RegulationIndex = () => {
    const { chartData } = useServicesChartsDataContext();

    return (
        <Gauge
            title={'Índice de Regulação Médica'}
            subtitle={'percentual de atendimentos com regulação médica'}
            subtitles={chartData?.medicalRegIndex?.map((item) => item.description) || []}
            chartData={chartData?.medicalRegIndex || []}
            colors={defaultColors.slice(0, chartData?.medicalRegIndex?.length) || []}
            height={400}
        />
    );
};
